import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import { validateExisting } from "../api/insuranceVerificationApi";
import { insuranceVerificationKeys } from "../api/insuranceVerificationKeys";
import { companyDocumentKeys } from "newui/features/Company/CompanyDocuments/companyDocumentKeys";

export const useValidateExistingDocument = (documentId: number) => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation({
    mutationFn: () => validateExisting(companyId as number, documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.documents(companyId as number),
      });
      queryClient.invalidateQueries({
        queryKey: companyDocumentKeys.documents(companyId as number),
      });
    },
  });
};
